export const LANG_EN_DICTIONARY = {
  LANG_EN: 'English',
  LANG_ES: 'Spanish',
  LANG_PT: 'Portuguese',
} as const;
